export default __webpack_public_path__ + "static/media/kepviselo.f93c70f4.png";